import {createAction} from 'redux-act'

import {createBasicActions} from '../../utils/redux'
import {initialState} from './constants'
import {GlobalState} from './types'
export const basicActions = createBasicActions<GlobalState>(initialState)

export const setAppLoadingState = createAction<boolean>('setAppLoadingState')
export const getUpdatedLocalizations = createAction<void>('getUpdatedLocalizations')
